import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LandingPage from "../LandingPage/LandingPage";
import History from "../AboutUs/History/History.jsx";
import Vision from "../AboutUs/Vision/Vision";
import Profile from "../AboutUs/Profile/Profile";
import AboutUsPage from "../AboutUs/AboutUsPage";
import AdministrationPage from "../Administration/AdministrationPage.jsx"
import President from "../Administration/President.jsx";
import Secretary from "../Administration/Secretary";
import Principal from "../Administration/Principal";
import StatutoryBodies from "../Administration/Statutory Bodies/StatutoryBodies.jsx";
import GoverningBodies from "../Administration/Statutory Bodies/Governing Bodies/GoverningBodies.jsx";
import AcademicCouncil from "../Administration/Statutory Bodies/Academic Council/AcademicCouncil.jsx";
import NonStatutoryBodies from "../Administration/NonStatutoryBodies/NonStatutoryBodies.jsx";
import ExaminationCommittee from "../Administration/NonStatutoryBodies/Examination Committee/ExaminationCommittee.jsx";
import ParentTeacherAssociation from "../Administration/NonStatutoryBodies/Parent Teacher Association/ParentTeacherAssociation.jsx";
import Ombudsman from "../Administration/Ombudsman.jsx";
import Academics from "../Academics/Academics";
import UG_Programmes from "../Academics/UG_Programmes/UG_Programmes";
import PG_Programmes from "../Academics/PG_Programmes/PG_Programmes";
import AcademicCalendar from "../Academics/AcademicCalendar/AcademicCalendar";
import OurStaff from "../Academics/Our_Staff/OurStaff";
import Library from "../Academics/Library/Library.jsx";
import CurriculumAndSyllabus from "../Academics/CurriculumAndSyllabus/CurriculumAndSyllabus";
import HigherEducation from "../Academics/HigherEducation/HigherEducation";

import CampusLife from "../CampusLife/CampusLife";
import ExtensionActivities from "../CampusLife/ExtensionActivities/ExtensionActivities";
import NSS from "../CampusLife/ExtensionActivities/NSS/NSS.jsx"
import NCC from "../CampusLife/ExtensionActivities/NCC/NCC.jsx"
import YRC from "../CampusLife/ExtensionActivities/YRC/YRC.jsx"
import RRC from "../CampusLife/ExtensionActivities/RRC/RRC.jsx"
import Iqac from "../IQAC/Iqac";
import Composition from "../IQAC/Composition/Composition.jsx";
import BestPractices from "../IQAC/Best Practices/BestPractices.jsx";
import Distinctiveness from "../IQAC/Distinctiveness/Distinctiveness.jsx";
import StaffCouncil from "../IQAC/Committees/Staff Council/StaffCouncil.jsx";
import StaffAssociation from "../IQAC/Staff Association/StaffAssociation.jsx";
import DisciplineCommittee from "../IQAC/Committees/Discipline Committee/DisciplineCommittee.jsx";
import WebsiteMaintenance from "../IQAC/Committees/Website Maintenance/WebsiteMaintenance.jsx";
import CollegeCouncil from "../IQAC/Committees/College Council/CollegeCouncil.jsx";
import Committees from "../IQAC/Committees/Committees.jsx";
import SportsAdvisory from "../IQAC/Committees/Sports Advisory/SportsAdvisory.jsx";
import Naac from "../IQAC/Best Practices/NAAC/Naac.jsx";
import AssessmentCriteria from "../IQAC/Best Practices/NAAC/Assessment Criteria/AssessmentCriteria.jsx";
import Minutes from "../IQAC/Best Practices/NAAC/Minutes/Minutes.jsx";
import Aqars from "../IQAC/Best Practices/NAAC/AQARS/Aqars.jsx";
import CalendarHandbook from "../IQAC/Best Practices/NAAC/CalendarHandbook.jsx/CalendarHandbook.jsx";
import Outcomes from "../IQAC/Best Practices/NAAC/Outcomes/Outcomes .jsx";
import Nirf from "../IQAC/NIRF/Nirf.jsx";
import Aishe from "../IQAC/AISHE/Aishe.jsx";
import AcademicAuditReportTemplate from "../IQAC/Academic Audit Report Template/AcademicAuditReportTemplate.jsx";

import Admission from "../Admission/Admission";
import AdmissionCommittee from "../Admission/AdmissionCommittee/AdmissionCommittee";
import Application from "../Admission/Application/Application";
import PlacementCareer from "../CampusLife/PlacementandCareer/PlacementCareer";
import InhouseTraining from "../CampusLife/PlacementandCareer/InhouseTraining/InhouseTraining";
import OutsourceTraining from "../CampusLife/PlacementandCareer/OutsourceTraining/OutsourceTraining";
import TNPSCexam from "../CampusLife/PlacementandCareer/TNPSCexam/TNPSCexam";
import StudentSupport from "../CampusLife/StudentSupport/StudentSupport";
import StudentCouncil from "../CampusLife/StudentSupport/StudentCouncil/StudentCouncil";
import Feedback from "../IQAC/Feedback/Feedback.jsx";
import StudentFeedback from "../IQAC/Feedback/StudentFeedback.jsx";
import TeacherFeedback from "../IQAC/Feedback/TeacherFeedback.jsx";
import Alumini from "../Alumini/Alumini.jsx";
import Objectives from "../Alumini/Objectives/Objectives.jsx";
import ExecutiveCommittee from "../Alumini/Executive Committee/ExecutiveCommittee.jsx";
import NewsLetter from "../Alumini/News Letter/NewsLetter.jsx";
import AchieversGallery from "../Alumini/Achievers Gallery/AchieversGallery.jsx";
import ProgrammesDynamicPage from "../Academics/Programmes Dynamic Page/ProgrammesDynamicPage.jsx";
import MentorMentee from "../CampusLife/StudentSupport/MentorMentee/MentorMentee.jsx";
import Scholarship from "../CampusLife/Scholarship/Scholarship.jsx";
import Club from "../CampusLife/Club/Club.jsx";
import SaveGreen from "../CampusLife/Club/SaveGreen/SaveGreen.jsx"
import CitizenConsumer from "../CampusLife/Club/CitizenConsumer/CitizenConsumer.jsx";
import Cultural from "../CampusLife/Club/Cultural/Cultural.jsx";
import Electrol from "../CampusLife/Club/Electrol/Electrol.jsx"
import QuizClub from "../CampusLife/Club/QuizClub/QuizClub.jsx"
import Rotaract from "../CampusLife/Club/Rotaract/Rotaract.jsx"
import LegalAID from "../CampusLife/Club/LegalAID/LegalAID.jsx"
import SkillEnhancement from "../CampusLife/SkillEnhancement/SkillEnhancement.jsx"
import Enterpreneurship from "../CampusLife/SkillEnhancement/EnterpreneurshipDevelopment/Enterpreneurship.jsx";
import InstitutionInnovation from "../CampusLife/SkillEnhancement/InstitutionInnovation/InstitutionInnovation.jsx"
import TNSTC from "../CampusLife/SkillEnhancement/TNSTC/TNSTC.jsx"
import ICTAcademy from "../AboutUs/ICTAcademy/ICTAcademy.jsx"
import MOU from "../AboutUs/MOU/MOU.jsx"
import Swayam from "../CampusLife/SkillEnhancement/SWAYAM/Swayam.jsx"
import Infrastructure from "../CampusLife/Infrastructure/Infrastructure.jsx"
import Laboratory from "../CampusLife/Infrastructure/Laboratory/Laboratory.jsx";
import InfraLibrary from "../CampusLife/Infrastructure/InfraLibrary/InfraLibrary.jsx"
import InfraHostel from "../CampusLife/Infrastructure/InfraHostel/InfraHostel.jsx"
import Transportation from "../CampusLife/Infrastructure/Transportation/Transportation.jsx"
import PlayGround from "../CampusLife/Infrastructure/PlayGround/PlayGround.jsx"
import Canteen from "../CampusLife/Infrastructure/Canteen/Canteen.jsx"
import Auditorium from "../CampusLife/Infrastructure/Auditorium/Auditorium.jsx"
import GreenCampus from "../CampusLife/Infrastructure/GreenCampus/GreenCampus.jsx"
import Gallery from "../Shared-Component/Footer/Gallery/Gallery.jsx";
import ContactUs from "../Shared-Component/Footer/ContactUs/ContactUs.jsx";
import AboutIqac from "../IQAC/AboutIQAC/AboutIqac.jsx";
import SSS from "../IQAC/SSS/SSS.jsx";
import Timeline from "../AboutUs/History/Timeline/Timeline.jsx";
import GrievanceRedressal from "../CampusLife/GrievanceRedressal/GrievanceRedressal.jsx";
import WomenCell from "../CampusLife/GrievanceRedressal/WomenCell/WomenCell.jsx";
import AntiRagging from "../CampusLife/GrievanceRedressal/AnitRagging/AntiRagging.jsx";
import AntiDrug from "../CampusLife/GrievanceRedressal/AntiDrug/AntiDrug.jsx";
import CyberCrime from "../CampusLife/GrievanceRedressal/CyberCrime/CyberCrime.jsx";
import InternalCompliance from "../CampusLife/GrievanceRedressal/InternalCompliance/InternalCompliance.jsx";
import GrievOmbudsman from "../CampusLife/GrievanceRedressal/GrievOmbudsman/GrievOmbudsman.jsx";
import LaboratoryDynamicPage from "../CampusLife/CampusSharedComponent/LaboratoryDynamicPage.jsx";
import HelpDesk from "../HelpDesk/Helpdeskmain.jsx";
import InquiryCareer from "../HelpDesk/InquiryCareer/ApplicationForStaff/ApplicationForStaff.jsx"
import InquiryDesk from "../HelpDesk/InquiryDesk/Inquirydesk.jsx"
import Login from "../Login/Login.jsx";
import { ToastContainer } from 'react-toastify';
import Research from "../Academics/Research/Research.jsx";
import Sports from "../CampusLife/ExtensionActivities/Sports/Sports.jsx";
import Admin from "../Admin/Admin.jsx";
import Dashboard from "../Admin/Admin Pages/Dashboard/Dashboard.jsx";
import Announcement from "../Admin/Admin Pages/Announcement/Announcement.jsx";
import Event from "../Admin/Admin Pages/Event/Event.jsx";
import News from "../Admin/Admin Pages/News/News.jsx";
import Academic_Audit_Template from "../Admin/Admin Pages/Reports/Academic Audit Template/AcademicAuditTemplate.jsx";
import Academic_Calendar_Page from "../Admin/Admin Pages/Reports/Academic Calendar/AcademiccalendarPage.jsx";
import Best_Practices from "../Admin/Admin Pages/Reports/Best Practices/BestPractices.jsx";
import Assessment_Criteria from "../Admin/Admin Pages/Reports/Assessment Criteria/AssessmentCriteria.jsx";
import MinutesPage from "../Admin/Admin Pages/Reports/Minutes/MinutesPage.jsx";
import AqarsPage from "../Admin/Admin Pages/Reports/Aqars/AqarsPage.jsx";
import OutcomesPage from "../Admin/Admin Pages/Reports/Outcomes/OutcomesPage.jsx";
import Achievers_Gallrey from "../Admin/Admin Pages/Achievers Gallery/Achievers_Gallrey.jsx";
import NirfPage from "../Admin/Admin Pages/Reports/Nirf/NirfPage.jsx";
import CalendarHandbookPage from "../Admin/Admin Pages/Reports/CalendarHandbook/CalendarHandbookPage.jsx";
import StudentParentPage from "../Admin/Admin Pages/HelpDesk/StudentParentPage.jsx";
import VisitorsPage from "../Admin/Admin Pages/HelpDesk/VisitorsPage.jsx";
import AishePage from "../Admin/Admin Pages/Reports/Aishe/AishePage.jsx";
import SSSPage from "../Admin/Admin Pages/Reports/SSS/SSSPage.jsx";
import StudentsFeedbackPage from "../Admin/Admin Pages/Feedback/StudentsFeedbackPage.jsx";
import TeachersFeedbackPage from "../Admin/Admin Pages/Feedback/TeachersFeedbackPage.jsx";
import NewsletterPage from "../Admin/Admin Pages/Reports/Newletter/NewsletterPage.jsx";
import DistinctivenessPage from "../Admin/Admin Pages/Reports/Distinctiveness/DistinctivenessPage.jsx";
import PGActivitiesPage from "../Admin/Admin Pages/Activities/PGActivitiesPage.jsx";
import UGActivitiesPage from "../Admin/Admin Pages/Activities/UGActivitiesPage.jsx";
import GalleryPage from "../Admin/Admin Pages/Gallery/GalleryPage.jsx";
import StaffApplicationPage from "../Admin/Admin Pages/Staff Application/StaffApplicationPage.jsx";
import OmbudsmanPage from "../Admin/Admin Pages/Ombudsman/OmbudsmanPage.jsx";
import AdmissionPage from "../Admin/Admin Pages/Admission/AdmissionPage.jsx"
import PasswordReset from "../Admin/Admin Pages/Reset Password/PasswordReset.jsx";
import Reports from "../Admin/Admin Pages/Reports/Reports.jsx";
import ProtectedRoute from "../components/ProtectedRoute.jsx";
import ContactMessages from "../Admin/Admin Pages/Contact/ContactMessages.jsx";
import Reader from "../CampusLife/Club/Reader/Reader.jsx";
import ParentFeedback from "../IQAC/Feedback/ParentFeedback.jsx";
import ParentFeedbackPage from "../Admin/Admin Pages/Feedback/ParentFeedbackPage.jsx";
import StudyMaterials from "../Admin/Admin Pages/StudyMaterials/StudyMaterialsAdmin.jsx";
import StudyMaterialsUi from "../Academics/StudyMaterials/StudyMaterialsUi.jsx";

const Navigation = () => {

    return (
        <>
            <ToastContainer />

            <Routes>
                <Route path="/Login" element={<Login />} />
                <Route path="/" element={<LandingPage />} />
                <Route path="/reset-password" element={<PasswordReset />} />

                {/* Routes for Admin Pages */}
                <Route path="/admin"
                    element={
                        <ProtectedRoute>
                            <Admin />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Dashboard />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="announcement" element={<Announcement />} />
                    <Route path="event" element={<Event />} />
                    <Route path="news" element={<News />} />
                    <Route path="iqac" element={<Reports />}>
                        <Route path="academic-audit-template" element={<Academic_Audit_Template />} />
                        <Route path="best-practices" element={<Best_Practices />} />
                        <Route path="assessment-criteria" element={<Assessment_Criteria />} />
                        <Route path="minutes-page" element={<MinutesPage />} />
                        <Route path="aqars-page" element={<AqarsPage />} />
                        <Route path="aishe-page" element={<AishePage />} />
                        <Route path="outcomes-page" element={<OutcomesPage />} />
                        <Route path="sss-page" element={<SSSPage />} />
                        <Route path="nirf-page" element={<NirfPage />} />
                        <Route path="calender-handbook-page" element={<CalendarHandbookPage />} />
                        <Route path="distinctiveness-page" element={< DistinctivenessPage />} />
                    </Route>
                    <Route path="/admin/academic-calendar" element={< Academic_Calendar_Page />} />
                    <Route path="helpdesk/students-parents-page" element={<StudentParentPage />} />
                    <Route path="helpdesk/visitors-page" element={<VisitorsPage />} />
                    <Route path="feedback/students-feedback-page" element={<StudentsFeedbackPage />} />
                    <Route path="feedback/parents-feedback-page" element={<ParentFeedbackPage />} />
                    <Route path="feedback/teachers-feedback-page" element={<TeachersFeedbackPage />} />
                    <Route path="pg-activities" element={<PGActivitiesPage />} />
                    <Route path="ug-activities" element={<UGActivitiesPage />} />
                    <Route path="gallery-page" element={<GalleryPage />} />
                    <Route path="staff-application-page" element={<StaffApplicationPage />} />
                    <Route path="ombudsman-page" element={<OmbudsmanPage />} />
                    <Route path="admission/application-for-admisssion" element={<AdmissionPage />} />
                    <Route path="contact-messages" element={<ContactMessages />} />
                    <Route path="/admin/alumini/newsletter" element={< NewsletterPage />} />
                    <Route path="/admin/alumini/achievers-gallery" element={<Achievers_Gallrey />} />
                    <Route path="/admin/study-materials" element={<StudyMaterials />} />
                </Route>

                {/* Routes for AboutUS */}
                <Route path="/aboutus" element={<AboutUsPage />}>
                    <Route path="history" element={<History />} />
                    <Route path="timeline" element={<Timeline />} />
                    <Route path="vision-mission" element={<Vision />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="ICT_Academy" element={<ICTAcademy />} />
                    <Route path="MOU" element={<MOU />} />
                </Route>

                {/* Routes for Administration */}
                <Route path="/administration" element={<AdministrationPage />}>
                    <Route path="president" element={<President />} />
                    <Route path="secretary" element={<Secretary />} />
                    <Route path="principal" element={<Principal />} />
                    <Route path="statutory-bodies" element={<StatutoryBodies />}>
                        <Route path="governing-bodies" element={<GoverningBodies />} />
                        <Route path="academic-council" element={<AcademicCouncil />} />
                    </Route>
                    <Route path="non-statutory-bodies" element={<NonStatutoryBodies />}>
                        <Route path="examination-committee" element={<ExaminationCommittee />} />
                        <Route path="parent-teacher-association" element={< ParentTeacherAssociation />} />
                    </Route>
                    <Route path="ombudsman" element={<Ombudsman />} />
                </Route>


                {/* Routes for Academics */}
                <Route path="/academics" element={<Academics />}>
                    <Route path="ug-programmes" element={<UG_Programmes />}>
                        <Route path=":courseName" element={<ProgrammesDynamicPage />} />
                    </Route>
                    <Route path="pg-programmes" element={<PG_Programmes />}>
                        <Route path=":courseName" element={<ProgrammesDynamicPage />} />
                    </Route>
                    <Route path="research" element={<Research />} />
                    <Route path="academic-calendar" element={<AcademicCalendar />} />
                    <Route path="our-staff" element={<OurStaff />} />
                    <Route path="library" element={<Library />} />
                    <Route path="curriculum-and-syllabus" element={<CurriculumAndSyllabus />} />
                    <Route path="study-materials" element={<StudyMaterialsUi />} />
                    <Route path="higher-education" element={<HigherEducation />} />
                </Route>

                {/* Routes for Campus Life */}
                <Route path="/Campus_Life" element={<CampusLife />}>
                    <Route path="Extension_Activities" element={<ExtensionActivities />}>
                        <Route path="NSS" element={<NSS />} />
                        <Route path="NCC" element={<NCC />} />
                        <Route path="YRC" element={<YRC />} />
                        <Route path="RRC" element={<RRC />} />
                        <Route path="Sports" element={<Sports />} />
                    </Route>
                    <Route path="Placement_and_Career" element={<PlacementCareer />}>
                        <Route path="Inhouse_Training" element={<InhouseTraining />} />
                        <Route path="Outsource_Training" element={<OutsourceTraining />} />
                        <Route path="TNPSC_-_Competitive_Exam_Coaching" element={<TNPSCexam />} />
                    </Route>
                    <Route path="Student_Support" element={<StudentSupport />}>
                        <Route path="Student_council" element={<StudentCouncil />} />
                        <Route path="Mentor_Mentee" element={<MentorMentee />} />
                    </Route>
                    <Route path="Scholarship" element={<Scholarship />} />
                    <Route path="Club" element={<Club />}>
                        <Route path="Save_Green_Club" element={<SaveGreen />} />
                        <Route path="Citizen_Consumer_Club" element={<CitizenConsumer />} />
                        <Route path="Cultural_Club" element={<Cultural />} />
                        <Route path="Electrol_Club" element={<Electrol />} />
                        <Route path="Quiz_Club" element={<QuizClub />} />
                        <Route path="Rotaract_Club" element={<Rotaract />} />
                        <Route path="Legal_AID_Club" element={<LegalAID />} />
                        <Route path="Reader_Club" element={<Reader />} />
                    </Route>
                    <Route path="Skill_Enhancement" element={<SkillEnhancement />}>
                        <Route path="Enterpreneurship_Development_Cell" element={<Enterpreneurship />} />
                        <Route path="Institution_Innovation_Council" element={<InstitutionInnovation />} />
                        <Route path="TNSTC_-_Naan_Mudhalva" element={<TNSTC />} />
                        <Route path="ICT_Academy" element={<ICTAcademy />} />
                        <Route path="SWAYAM_-_NPTEL_-_MOOC" element={<Swayam />} />
                    </Route>
                    <Route path="Infrastructure" element={<Infrastructure />}>

                        <Route path="Laboratory_Facility" element={<Laboratory />} >
                            <Route path=":labName" element={<LaboratoryDynamicPage />} />
                        </Route>

                        <Route path="Library" element={<InfraLibrary />} />
                        <Route path="Hostel" element={<InfraHostel />} />
                        <Route path="Transportation" element={<Transportation />} />
                        <Route path="Play_Ground" element={<PlayGround />} />
                        <Route path="Canteen" element={<Canteen />} />
                        <Route path="Auditorium" element={<Auditorium />} />
                        <Route path="Green_Campus" element={<GreenCampus />} />
                    </Route>
                    <Route path="Grievance_Redressal" element={<GrievanceRedressal />} >
                        <Route path="Women_Cell" element={<WomenCell />} />
                        {/* <Route path="Sexual_Harrasment_Cell" element={<SexualHarrasment />} /> */}
                        <Route path="Anti_Ragging_-_Eve_teasing" element={<AntiRagging />} />
                        <Route path="Anti_Drug_Awareness" element={<AntiDrug />} />
                        <Route path="Cyber_Crime_Awareness" element={<CyberCrime />} />
                        <Route path="Internal_Compliance_Committee" element={<InternalCompliance />} />
                        <Route path="Ombudsman" element={<GrievOmbudsman />} />
                    </Route>
                </Route>

                <Route path="/iqac" element={< Iqac />}>
                    <Route path="about" element={<AboutIqac />} />
                    <Route path="best-practices" element={<BestPractices />} />
                    <Route path="distinctiveness" element={<Distinctiveness />} />
                    <Route path="composition" element={<Composition />} />
                    <Route path="committees" element={<Committees />}>
                        <Route path="staff-council" element={<StaffCouncil />} />
                        <Route path="staff-association" element={<StaffAssociation />} />
                        <Route path="discipline-committee" element={<DisciplineCommittee />} />
                        <Route path="sports-advisory" element={<SportsAdvisory />} />
                        <Route path="website-maintenance" element={<WebsiteMaintenance />} />
                        <Route path="college-council" element={<CollegeCouncil />} />
                    </Route>
                    <Route path="naac" element={<Naac />}>
                        <Route path="assessment-criteria" element={<AssessmentCriteria />} />
                        <Route path="minutes" element={<Minutes />} />
                        <Route path="aqars" element={<Aqars />} />
                        <Route path="calendar-handbook" element={<CalendarHandbook />} />
                        <Route path="outcomes" element={<Outcomes />} />
                    </Route>
                    <Route path="nirf" element={<Nirf />} />
                    <Route path="aishe" element={<Aishe />} />
                    <Route path="academic-audit-report" element={<AcademicAuditReportTemplate />} />
                    <Route path="feedback" element={<Feedback />}>
                        <Route path="sss" element={<SSS />} />
                        <Route path="student-feedback" element={<StudentFeedback />} />
                        <Route path="teacher-feedback" element={<TeacherFeedback />} />
                        <Route path="employee-feedback" element={<ParentFeedback />} />
                    </Route>
                </Route>
                {/* 
                <Route path="/Career" element={<Career />}>
                    <Route path="Application_For_Staff" element={<ApplicationForStaff />} />
                </Route> */}

                <Route path="/Admission" element={<Admission />} >
                    <Route path="Admission_Committee" element={<AdmissionCommittee />} />
                    <Route path="Application_For_Admission" element={<Application />} />
                </Route>

                {/* Routes for Alumini */}
                <Route path="/alumini" element={<Alumini />}>
                    <Route path="objectives" element={<Objectives />} />
                    <Route path="executive-committee" element={<ExecutiveCommittee />} />
                    <Route path="news-letter" element={<NewsLetter />} />
                    <Route path="achievers-gallery" element={<AchieversGallery />} />
                </Route>
                <Route path="/Gallery" element={<Gallery />} />
                <Route path="/Contact_Us" element={<ContactUs />} />

                {/* Route for Help Desk */}
                <Route path="/Helpdesk" element={<HelpDesk />} >
                    <Route path="Inquiry-Desk" element={<InquiryDesk />} />
                    <Route path="Inquiry-Career" element={<InquiryCareer />} />
                </Route>
            </Routes>
        </>
    )
};

export default Navigation;
